export const getAvisFormConfig = (props, isUnionPay) => ({
  ...props,
  zipcodeEnable: false,
  requireEmail: false,
  requirePhone: false,
  showPhone: true,
  showUnionPayFields: isUnionPay,
});

export const buildAvisRequest = (formData, props, verificationCode) => {
  const [expiryMonth, expiryYear] = formData.cardExpiryDate.split(" / ");
  const request = {
    fleetId: props.fleetId,
    userId: props.userId ?? props.i,
    transactionId: props.tranId,
    cardNumber: formData.cardNumber.replace(/\s+/g, ""),
    expiredDate: `${expiryMonth}/20${expiryYear}`,
    cvv: formData.cardCVC,
    cardHolder: formData.cardHolder,
  };

  if (formData.phone?.trim()) request.phone = formData.phone.trim();
  if (formData.creditType) request.creditType = formData.creditType;
  if (formData.creditCode?.trim()) request.creditCode = formData.creditCode.trim();
  if (verificationCode?.trim()) request.data3ds = verificationCode.trim();
  return request;
};

export const getAvisSuccessUrl = (props) =>
  props.u ?? props.returnUrl ?? null;
